import { create } from 'zustand';

import { storage } from '@/lib/storage';

const DEFAULT_REDIRECT_PATH = '/dashboard';

const normalizeRedirectPath = (path: string) => (path.trim() ? path : DEFAULT_REDIRECT_PATH);

export type AuthState = {
  isAuthenticated: boolean;
  redirectPath: string;
  login: () => void;
  logout: () => void;
  setRedirectPath: (path: string) => void;
  resetRedirectPath: () => void;
};

export const useAuthStore = create<AuthState>(set => ({
  isAuthenticated: storage.hasToken(),
  redirectPath: DEFAULT_REDIRECT_PATH,
  login: () => set({ isAuthenticated: true }),
  logout: () => {
    storage.removeToken();
    set({ isAuthenticated: false, redirectPath: DEFAULT_REDIRECT_PATH });
  },
  setRedirectPath: path => set({ redirectPath: normalizeRedirectPath(path) }),
  resetRedirectPath: () => set({ redirectPath: DEFAULT_REDIRECT_PATH }),
}));
